/* eslint-disable no-shadow */
import React, { RefAttributes, useMemo, Dispatch } from "react";
import { react } from "uikit";

import Language from "../../../../../../../../../../services/Language";

import { Root, MainTab } from "./components";
import InternalController from "./Controller";

const Content = react.withController<Content.PropsBase, Content.Controller>(
	({ value, type, disabled, language }) => {
		const content = useMemo(
			() => (
				<>
					<MainTab
						value={value}
						disabled={disabled}
						visible={type === "main"}
						language={language}
					/>
				</>
			),
			[disabled, language, type, value],
		);

		return <Root>{content}</Root>;
	},
	InternalController,
);

declare namespace Content {
	type Ref = InternalController | null;

	type Controller = InternalController;

	type Type = "main";

	type Value = any;

	interface PropsBase {
		value: Value;

		type: Type;
		disabled: boolean;
		language: Language;

		onChange: Dispatch<Value>;
	}

	type Props = PropsBase & RefAttributes<Ref>;
}

export default Content;
